import {defineAsyncComponent} from 'vue';

export const ClaimReferralCouponPopup = defineAsyncComponent(
  () => import('./components/ClaimReferralCouponPopup.vue')
);
export const ShareReferralPopup = defineAsyncComponent(
  () => import('./components/ShareReferralPopup.vue')
);
